// Generated by scripts/generate-message-ids.mjs from message-ids.source.json.

export const MESSAGE_IDS = {
  adminOnly: 'admin_only',
  approvalRequired: 'approval_required',
  cycleDetected: 'cycle_detected',
  delegationTargetIneligible: 'delegation_target_ineligible',
  dbError: 'db_error',
  internalServerError: 'internal_server_error',
  invalidCode: 'invalid_code',
  invalidCredentials: 'invalid_credentials',
  invalidToken: 'invalid_token',
  kycEmailAlreadyVerified: 'kyc_email_already_verified',
  kycEmailTokenExpired: 'kyc_email_token_expired',
  kycEmailTokenInvalid: 'kyc_email_token_invalid',
  kycEmailSendFailed: 'kyc_email_send_failed',
  kycL2TooManyAttempts: 'kyc_l2_too_many_attempts',
  kycL2DocumentInvalid: 'kyc_l2_document_invalid',
  kycL3TooManyAttempts: 'kyc_l3_too_many_attempts',
  kycL3FaceMatchFailed: 'kyc_l3_face_match_failed',
  kycLevelInsufficient: 'kyc_level_insufficient',
  llmProviderUnavailable: 'llm_provider_unavailable',
  llmRequestFailed: 'llm_request_failed',
  missingToken: 'missing_token',
  phoneVerificationFailed: 'phone_verification_failed',
  requestFailed: 'request_failed',
  selfDelegationForbidden: 'self_delegation_forbidden',
  smsSendFailed: 'sms_send_failed',
  telegramChatNotFound: 'telegram_chat_not_found',
  telegramNotConfigured: 'telegram_not_configured',
  telegramSendFailed: 'telegram_send_failed',
  unknownError: 'unknown_error',
  userNotFound: 'user_not_found',
  validationCodeInvalid: 'validation_code_invalid',
  validationCodeRequired: 'validation_code_required',
  validationDelegateTargetInvalid: 'validation_delegate_target_invalid',
  validationDelegateTargetRequired: 'validation_delegate_target_required',
  validationDeviceIdInvalid: 'validation_device_id_invalid',
  validationError: 'validation_error',
  validationLlmMessageRequired: 'validation_llm_message_required',
  validationLlmMessageTooLong: 'validation_llm_message_too_long',
  validationPhoneInvalid: 'validation_phone_invalid',
  validationPhoneRequired: 'validation_phone_required',
};
